import { render, staticRenderFns } from "./warehouse-patch-edit.vue?vue&type=template&id=116a1234&scoped=true&"
import script from "./warehouse-patch-edit.vue?vue&type=script&lang=ts&"
export * from "./warehouse-patch-edit.vue?vue&type=script&lang=ts&"
import style0 from "./warehouse-patch-edit.vue?vue&type=style&index=0&id=116a1234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a1234",
  null
  
)

export default component.exports